<template>
  <div
    class="report-block">
    {{ copyrightReports[0].year }}年{{ copyrightReports[0].quarter }}期の著作権収益報告書です。
    下記よりダウンロードください。
    <div
      class="report-finalized-download-buttons-area">
      <finalized-report-download-buttons
        :is-copyright-report="true"
        :payment_id="0"
        :reports="copyrightReports" />
    </div>
  </div>
</template>

<script>
import FinalizedReportDownloadButtons from '../../Report/FinalizedReportDownloadButtons'

export default {
  components: {
    FinalizedReportDownloadButtons,
  },
  props: {
    copyrightReports: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
  },
}
</script>

<style scoped>

</style>
